export default "__VITE_ASSET__8tVI6irO__"